// Partners.js - Adam International Academy Documents Version
import React, { useState, useEffect, useRef } from 'react';
import './Partners.css';

// YENİ LOGOLAR - SADECE BUNLAR KALACAK
import abcHorizon from '../../assets/partners/abc-horizon.png';
import studyfans from '../../assets/partners/studyfans.png';
import ghEducation from '../../assets/partners/gh-education.png';
import adamHoldingUnion from '../../assets/partners/adam-holding-union.png';
import scopeAcademy from '../../assets/partners/scope-academy.png';
import Target from '../../assets/partners/Target.png';
import Afrecom from '../../assets/partners/Afrecom.jpg';
import Ecopa from '../../assets/partners/Ecopa.jpg';
import medipol from '../../assets/partners/medipol.png';
import sabahattinZaim from '../../assets/partners/sabahattin-zaim.png';
import aitu from '../../assets/partners/aitu.png';
import adamBank from '../../assets/partners/adam-bank.png';
import adamGlobalFoundation from '../../assets/partners/adam-global-foundation.png';
import sak from '../../assets/partners/sak.png';

// Placeholder logolar (gerçek projede gerçek logolar eklenecek)


const Partners = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => ({
              ...prev,
              [entry.target.dataset.section]: true
            }));
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px' }
    );

    Object.values(sectionRefs.current).forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      Object.values(sectionRefs.current).forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  // Modal scroll lock
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  // Partner categories from AIA Partners document
  const categories = [
    { id: 'all', name: 'All Partners', icon: '🌟', count: 25 },
    { id: 'un', name: 'UN Agencies', icon: '🇺🇳', count: 5 },
    { id: 'university', name: 'Universities', icon: '🎓', count: 7 },
    { id: 'development', name: 'Development Agencies', icon: '🌍', count: 4 },
    { id: 'corporate', name: 'Corporate', icon: '🏢', count: 7 },
    { id: 'ngo', name: 'NGOs & CSOs', icon: '🤝', count: 3 },
    { id: 'research', name: 'Research Centers', icon: '🔬', count: 2 }
  ];

  // Partners from documents - SADECE YENİ LOGOLAR KULLANILDI
  const partners = [
    // United Nations Agencies (placeholder logolar)


    // University Partners - YENİ LOGOLAR
    {
      id: 5,
      name: 'Sabahattin Zaim University',
      category: 'university',
      description: 'Academic partnership for joint Master\'s and PhD programs in Political Science, International Relations, and Strategic Studies.',
      logo: sabahattinZaim,
      since: '2021',
      projects: '12+',
      focus: ['Graduate Programs', 'Joint Research', 'Faculty Exchange'],
      partnershipType: 'Academic Partner',
      location: 'Istanbul, Turkey',
      featured: true
    },
    {
      id: 6,
      name: 'Medipol University',
      category: 'university',
      description: 'Collaboration on health management programs, executive education, and joint certification courses.',
      logo: medipol,
      since: '2021',
      projects: '10+',
      focus: ['Health Management', 'Executive Education', 'Certification'],
      partnershipType: 'Academic Partner',
      location: 'Istanbul, Turkey'
    },
    {
      id: 7,
      name: 'American International Theism University',
      category: 'university',
      description: 'Accreditation partnership for online degree programs and professional certificates.',
      logo: aitu,
      since: '2022',
      projects: '7+',
      focus: ['Online Degrees', 'Accreditation', 'Professional Certificates'],
      partnershipType: 'Accreditation Partner',
      location: 'USA'
    },

    {
      id: 9,
      name: 'ABC Horizon University',
      category: 'university',
      description: 'Dual degree programs and faculty development initiatives with UK-Turkey collaboration.',
      logo: abcHorizon,
      since: '2022',
      projects: '6+',
      focus: ['Dual Degrees', 'Faculty Development', 'Research'],
      partnershipType: 'Strategic Academic Partner',
      location: 'Turkey - UK',
      featured: true
    },
    {
      id: 22,
      name: 'SAK',
      category: 'university',
      description: 'Academic partnership for collaborative research and student exchange programs.',
      logo: sak,
      since: '2023',
      projects: '3+',
      focus: ['Academic Exchange', 'Research Collaboration'],
      partnershipType: 'Academic Partner',
      location: 'Turkey'
    },

    // Development Agencies
    {
      id: 10,
      name: 'Turkish Cooperation and Coordination Agency (TİKA)',
      category: 'development',
      description: 'Capacity development programs and technical assistance in Africa and Central Asia.',
      logo: ghEducation, // GH Education logosu kullanıldı
      since: '2022',
      projects: '9+',
      focus: ['Technical Assistance', 'Capacity Building', 'Development Programs'],
      partnershipType: 'Development Partner'
    },
    {
      id: 11,
      name: 'Islamic Development Bank (IsDB)',
      category: 'development',
      description: 'Joint initiatives in education financing and human capital development across member countries.',
      logo: ghEducation, // GH Education logosu kullanıldı
      since: '2023',
      projects: '5+',
      focus: ['Education Financing', 'Human Capital', 'Sustainable Development'],
      partnershipType: 'Financial Partner'
    },

    // Corporate Partners - YENİ LOGOLAR
    {
      id: 12,
      name: 'Adam Holding Union',
      category: 'corporate',
      description: 'Parent organization connecting all Adam group brands across 9 sectors including Commerce, Education, Industry, and Technology.',
      logo: adamHoldingUnion,
      since: '2018',
      projects: '25+',
      focus: ['Strategic Management', 'Investment', 'Innovation', 'Cross-sector Collaboration'],
      partnershipType: 'Strategic Partner',
      featured: true
    },
    {
      id: 13,
      name: 'Adam Business Club',
      category: 'corporate',
      description: 'Business incubation and entrepreneurship support network for startups and SMEs.',
      logo: adamHoldingUnion, // Adam Holding Union logosu kullanıldı
      since: '2020',
      projects: '15+',
      focus: ['Entrepreneurship', 'Business Incubation', 'Networking'],
      partnershipType: 'Business Partner'
    },
    {
      id: 14,
      name: 'Adam Bank',
      category: 'corporate',
      description: 'Financial services and investment support for educational technology startups.',
      logo: adamBank,
      since: '2023',
      projects: '3+',
      focus: ['FinTech', 'Startup Investment', 'Educational Finance'],
      partnershipType: 'Financial Partner'
    },
    {
      id: 23,
      name: 'Target',
      category: 'corporate',
      description: 'Strategic corporate partner supporting educational initiatives and professional development programs.',
      logo: Target,
      since: '2022',
      projects: '4+',
      focus: ['Corporate Training', 'Professional Development'],
      partnershipType: 'Corporate Partner'
    },
    {
      id: 24,
      name: 'Afrecom',
      category: 'corporate',
      description: 'Partnership for educational and development programs across Africa.',
      logo: Afrecom,
      since: '2023',
      projects: '3+',
      focus: ['African Development', 'Educational Programs'],
      partnershipType: 'Regional Partner'
    },
    {
      id: 25,
      name: 'Ecopa',
      category: 'corporate',
      description: 'Collaboration on environmental sustainability and educational projects.',
      logo: Ecopa,
      since: '2022',
      projects: '4+',
      focus: ['Environmental Education', 'Sustainability'],
      partnershipType: 'Program Partner'
    },

    // NGOs & CSOs - YENİ LOGOLAR
    {
      id: 15,
      name: 'Adam Global Foundation',
      category: 'ngo',
      description: 'Nonprofit organization promoting sustainability, social development, and educational access.',
      logo: adamGlobalFoundation,
      since: '2020',
      projects: '8+',
      focus: ['Sustainability', 'Social Impact', 'Educational Access'],
      partnershipType: 'NGO Partner'
    },
    {
      id: 16,
      name: 'Scope Academy Foundation',
      category: 'ngo',
      description: 'Educational nonprofit focused on digital literacy and vocational training.',
      logo: scopeAcademy,
      since: '2022',
      projects: '6+',
      focus: ['Digital Literacy', 'Vocational Training', 'Youth Development'],
      partnershipType: 'Program Partner'
    },

    // Research Centers
    {
      id: 17,
      name: 'Adam Center for Consulting, Research and Studies',
      category: 'research',
      description: 'In-house research center focusing on economic feasibility studies, policy analysis, and international arbitration.',
      logo: adamHoldingUnion, // Adam Holding Union logosu kullanıldı
      since: '2018',
      projects: '20+',
      focus: ['Economic Research', 'Policy Analysis', 'Arbitration'],
      partnershipType: 'Research Partner',
      featured: true
    },
    {
      id: 18,
      name: 'GH Education Research Institute',
      category: 'research',
      description: 'Collaborative research on educational methodologies and learning technologies.',
      logo: ghEducation,
      since: '2021',
      projects: '7+',
      focus: ['Educational Research', 'Learning Technologies', 'Methodology'],
      partnershipType: 'Research Partner'
    },

    // Additional Corporate/Education - YENİ LOGOLAR
    {
      id: 19,
      name: 'StudyFans International',
      category: 'education',
      description: 'Student recruitment and study abroad consulting services for international students.',
      logo: studyfans,
      since: '2019',
      projects: '15+',
      focus: ['Student Recruitment', 'Study Abroad', 'Consulting'],
      partnershipType: 'Education Partner'
    },
    {
      id: 20,
      name: 'Adam Store',
      category: 'corporate',
      description: 'Educational products and resources for students and professionals.',
      logo: adamBank, // Adam Bank logosu kullanıldı
      since: '2021',
      projects: '8+',
      focus: ['Educational Products', 'Resources', 'E-Commerce'],
      partnershipType: 'Commercial Partner'
    }
  ];

  // Filtered partners
  const filteredPartners = activeCategory === 'all' 
    ? partners 
    : partners.filter(partner => partner.category === activeCategory);

  // Modal functions
  const openPartnerModal = (partner) => {
    setSelectedPartner(partner);
    setIsModalOpen(true);
  };

  const closePartnerModal = () => {
    setIsModalOpen(false);
    setSelectedPartner(null);
  };

  // Partnership benefits from documents
  const benefits = [
    {
      icon: '🌍',
      title: 'Global Reach',
      description: 'Access to networks in 30+ countries across Africa, Europe, Asia, and the Middle East'
    },
    {
      icon: '🤝',
      title: 'Strategic Collaboration',
      description: 'Joint development of capacity building programs aligned with SDG 2030'
    },
    {
      icon: '📚',
      title: 'Multilingual Education',
      description: 'Co-create content in English, Arabic, Turkish, and French for global audiences'
    },
    {
      icon: '🔬',
      title: 'Research & Innovation',
      description: 'Collaborate on peer-reviewed publications and cutting-edge educational technologies'
    }
  ];

  return (
    <div className="partners-page">
      {/* Hero Section - Updated */}
      <section className="partners-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Strategic Partnerships</h1>
            <p>Collaborating with United Nations agencies, universities, development organizations, and global leaders to advance SDG 2030 and capacity development</p>
            <div className="hero-stats">
              <div className="stat">
                <span className="number">50+</span>
                <span className="label">Global Partners</span>
              </div>
              <div className="stat">
                <span className="number">30+</span>
                <span className="label">Countries</span>
              </div>
              <div className="stat">
                <span className="number">8</span>
                <span className="label">Partner Categories</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="floating-logos">
              <div className="logo-item item-1">
                <img src={adamHoldingUnion} alt="Adam Holding Union" />
              </div>
              <div className="logo-item item-2">
                <img src={abcHorizon} alt="ABC Horizon" />
              </div>
              <div className="logo-item item-3">
                <img src={sabahattinZaim} alt="Sabahattin Zaim University" />
              </div>
              <div className="logo-item item-4">
                <img src={medipol} alt="Medipol University" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Benefits */}
      <section 
        className="partnership-benefits"
        ref={el => sectionRefs.current.benefits = el}
        data-section="benefits"
      >
        <div className={`container ${visibleSections.benefits ? 'visible' : ''}`}>
          <div className="section-header">
            <h2>Why Partner with Adam Academy?</h2>
            <p>Join our network of global partners and create meaningful impact together</p>
          </div>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Gallery */}
      <section 
        className="partners-gallery"
        ref={el => sectionRefs.current.gallery = el}
        data-section="gallery"
      >
        <div className={`container ${visibleSections.gallery ? 'visible' : ''}`}>
          <div className="section-header">
            <h2>Our Strategic Partners</h2>
            <p>Collaborating with United Nations agencies, universities, and organizations worldwide</p>
          </div>
          
          {/* Categories Filter */}
          <div className="categories-filter">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
                aria-label={`Filter by ${category.name}`}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-name">{category.name}</span>
                <span className="category-count">{category.count}</span>
              </button>
            ))}
          </div>

          {/* Partners Grid */}
          <div className="partners-grid">
            {filteredPartners.map(partner => (
              <div 
                key={partner.id} 
                className={`partner-card ${partner.featured ? 'featured' : ''}`}
                onClick={() => openPartnerModal(partner)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === 'Enter' && openPartnerModal(partner)}
                aria-label={`View details for ${partner.name}`}
              >
                {partner.featured && <div className="featured-badge">Featured Partner</div>}
                <div className="partner-logo">
                  <img src={partner.logo} alt={partner.name} loading="lazy" />
                </div>
                <div className="partner-info">
                  <h3>{partner.name}</h3>
                  <p className="partner-type">{partner.partnershipType}</p>
                  <p className="partner-description">{partner.description.substring(0, 100)}...</p>
                  <div className="partner-meta">
                    <span>Since {partner.since}</span>
                    <span>{partner.projects} projects</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Process */}
      <section 
        className="partnership-process"
        ref={el => sectionRefs.current.process = el}
        data-section="process"
      >
        <div className={`container ${visibleSections.process ? 'visible' : ''}`}>
          <div className="section-header">
            <h2>Partnership Process</h2>
            <p>How we build successful, long-term strategic partnerships</p>
          </div>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Initial Discussion</h3>
              <p>We explore alignment with SDG 2030 goals and identify mutual benefits</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Memorandum of Understanding</h3>
              <p>Formalize collaboration framework and define areas of cooperation</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Joint Program Design</h3>
              <p>Co-create capacity development initiatives and research projects</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Implementation & Impact</h3>
              <p>Execute programs and measure impact on sustainable development goals</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section 
        className="partner-testimonials"
        ref={el => sectionRefs.current.testimonials = el}
        data-section="testimonials"
      >
        <div className={`container ${visibleSections.testimonials ? 'visible' : ''}`}>
          <div className="section-header">
            <h2>What Our Partners Say</h2>
            <p>Hear from organizations that have partnered with Adam Academy</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Adam International Academy's commitment to SDG 2030 and capacity development aligns perfectly with our mission. Together, we've trained over 500 development professionals across Africa."</p>
              </div>
              <div className="testimonial-author">
                <h4>UNDP Representative</h4>
                <p>United Nations Development Programme</p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Our dual degree programs with Adam Academy have enabled students to gain international perspectives while studying locally. The faculty exchange program has been particularly valuable."</p>
              </div>
              <div className="testimonial-author">
                <h4>Prof. Dr. Mehmet Bulut</h4>
                <p>Sabahattin Zaim University</p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"The multilingual education programs developed through our partnership have reached thousands of learners in their native languages. Adam Academy's expertise in content adaptation is exceptional."</p>
              </div>
              <div className="testimonial-author">
                <h4>UNESCO Education Sector</h4>
                <p>Paris Headquarters</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="partners-cta"
        ref={el => sectionRefs.current.cta = el}
        data-section="cta"
      >
        <div className={`container ${visibleSections.cta ? 'visible' : ''}`}>
          <div className="cta-content">
            <h2>Become a Strategic Partner</h2>
            <p>Join our network of global partners and together let's advance sustainable development through education</p>
            <div className="cta-buttons">
              <button className="btn primary">Explore Partnership Opportunities</button>
              <button className="btn outline">Contact Partnership Team</button>
            </div>
            <div className="cta-contact">
              <p>📞 (+90) 380-772631 | ✉️ partnerships@adaminternationalacademy.com</p>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Modal */}
      {isModalOpen && selectedPartner && (
        <div className="partner-modal">
          <div className="modal-overlay" onClick={closePartnerModal}></div>
          <div className="modal-content">
            <button className="modal-close" onClick={closePartnerModal} aria-label="Close modal">×</button>
            <div className="modal-header">
              <div className="partner-logo">
                <img src={selectedPartner.logo} alt={selectedPartner.name} />
              </div>
              <div className="partner-title">
                <h2>{selectedPartner.name}</h2>
                <p>{selectedPartner.partnershipType} • Since {selectedPartner.since}</p>
                {selectedPartner.location && <p className="partner-location">📍 {selectedPartner.location}</p>}
              </div>
            </div>
            <div className="modal-body">
              <div className="partner-details">
                <div className="detail-item">
                  <span className="label">Partnership Focus:</span>
                  <div className="focus-areas">
                    {selectedPartner.focus.map((area, index) => (
                      <span key={index} className="focus-tag">{area}</span>
                    ))}
                  </div>
                </div>
                <div className="detail-item">
                  <span className="label">Collaborative Projects:</span>
                  <span className="value">{selectedPartner.projects}</span>
                </div>
                {selectedPartner.website && (
                  <div className="detail-item">
                    <span className="label">Website:</span>
                    <a href={selectedPartner.website} target="_blank" rel="noopener noreferrer" className="partner-website">
                      {selectedPartner.website}
                    </a>
                  </div>
                )}
              </div>
              <div className="partner-description">
                <h3>About the Partnership</h3>
                <p>{selectedPartner.description}</p>
              </div>
              <div className="success-stories">
                <h3>Key Achievements</h3>
                <ul>
                  <li>Joint capacity development programs reaching thousands of professionals</li>
                  <li>Co-created multilingual educational content aligned with SDG 2030</li>
                  <li>Successful research collaborations and peer-reviewed publications</li>
                  <li>Expanded educational access across 30+ countries</li>
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn outline" onClick={closePartnerModal}>Close</button>
              <button className="btn primary">Contact Partner Team</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Partners;